import React, { FocusEventHandler } from "react";
import { ChangeHandler } from "react-hook-form";

interface Option {
  value: number | string;
  label: string;
}

export interface SimpleSelectProps {
  label?: string;
  name: string;
  value?: string;
  options: Option[];
  hasEmpty?: boolean;
  help?: string;
  onChange?: ChangeHandler;
  onBlur?: FocusEventHandler;
}

const SimpleSelect = React.forwardRef<HTMLSelectElement, SimpleSelectProps>(
  (
    {
      label,
      value = undefined,
      hasEmpty = true,
      name,
      help,
      options,
      onChange = undefined,
      onBlur = undefined,
    },
    ref
  ) => {
    return (
      <div>
        {label ? (
          <label
            htmlFor={name}
            className="block text-sm font-medium text-navy-500"
          >
            {label}
          </label>
        ) : null}
        <div className="mt-1">
          <select
            ref={ref}
            name={name}
            id={name}
            value={value}
            onBlur={onBlur}
            onChange={onChange}
            className="shadow-sm focus:ring-teal-500 focus:border-teal-500 block w-full sm:text-sm border-ranga-300 rounded-md"
            aria-describedby={`${name}-description`}
          >
            {hasEmpty && <option value=""></option>}
            {options.map((opt: Option) => (
              <option
                value={opt.value}
                key={opt.value}
                // selected={opt.value === value}
              >
                {opt.label}
              </option>
            ))}
          </select>
        </div>
        {help ? (
          <p
            className="mt-2 pl-0.5 text-sm text-navy-500 opacity-75"
            id={`${name}-description`}
          >
            {help}
          </p>
        ) : null}
      </div>
    );
  }
);

SimpleSelect.displayName = "SimpleSelect";

export default SimpleSelect;

/*
<div>
  <label htmlFor="location" className="block text-sm font-medium text-gray-700">
    Location
  </label>
  <select
    id="location"
    name="location"
    className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
    defaultValue="Canada"
  >
    <option>United States</option>
    <option>Canada</option>
    <option>Mexico</option>
  </select>
</div>;
*/
